import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import { Alert, AlertTitle } from "@mui/material";
import { CheckCircle, XCircle } from "lucide-react";
import { homeRoutePath } from "../CoreRouter";

const PaymentStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
    const { checkout, status } = queryParams;

    // Redirect to 404 if required params are missing
    if (!checkout || !status || checkout !== "joinProPlan") {
      navigate("/404", { replace: true });
      return;
    }

    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate(homeRoutePath);
    }, 5000);

    return () => clearTimeout(timer);
  }, [location, navigate]);

  const queryParams = queryString.parse(location.search);
  const { status } = queryParams;

  const isSuccess = status === "1";

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {isSuccess ? (
          <Alert severity="success" icon={<CheckCircle className="h-5 w-5" />}>
            <AlertTitle>Payment Successful</AlertTitle>
            Your subscription plan has been activated successfully. You will be
            redirected to home to log in again, in 5 seconds.
          </Alert>
        ) : (
          <Alert severity="error" icon={<XCircle className="h-5 w-5" />}>
            <AlertTitle>Payment Failed</AlertTitle>
            There was an issue processing your payment. Please try again or
            contact support if the problem persists. You will be redirected to
            home in 5 seconds.
          </Alert>
        )}
      </div>
    </div>
  );
};

export default PaymentStatus;
